import React from "react";
import MainLayout from "../../../components/Layouts";
import ShopProductAddOnsList from "../../../components/Shop/Product/AddOns";

const ShopProductAddOnsPage = () => {
  return (
    <MainLayout>
      <ShopProductAddOnsList />
    </MainLayout>
  );
};

export default ShopProductAddOnsPage;
